import React, { useEffect, useState } from "react";

//UI Material
import {
  Button,
  Card,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TablePagination,
  TableRow,
  TextField,
  Typography,
} from "@mui/material";

//Material Icons
import { ArrowBackIos } from "@mui/icons-material";

//Helpers
import { fetchWithTokenJSONPost } from "../Helpers/network";
import { searchEngine } from "../Helpers/searchEngine";

//Local Components
import ErrorBox from "../Components/ErrorBox";
import QuoteRow from "../Components/quotes-page/QuoteRow";
import DataLoader from "../Components/basics/DataLoader";
import ElementCard from "../ProComponents/ElementCard";

export default function Quotes() {
  // ==========>Component States<==========
  //State for select page
  const [page, setPage] = useState(0);
  //State for manage rows per page
  const [rowsPerPage, setRowsPerPage] = useState(25);
  //State for setting loader for orders data
  const [dataLoader, setDataLoader] = useState(false);
  //State for setting error when could not get orders data
  const [dataError, setDataError] = useState(false);
  //State for quotes list
  const [quotes, setQuotes] = useState([]);
  //State for search data by query
  const [searchQuery, setSearchQuery] = useState("");

  // ==========>Component UseEffects<==========
  //The useEffect checks for token validation
  useEffect(() => {
    getQuotesList();
    const interval = setInterval(() => {
      getQuotesList();
    }, 300000);
    return () => {
      clearInterval(interval);
    };
  }, []);

  // ==========> Component Functions <==========
  //Function to manage page selection
  const handleChangePage = (_event, newPage) => {
    setPage(newPage);
  };

  //Function to control rows per page options
  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  //Function to generate unique id for each product added to the quote
  const generateId = () => {
    const timestamp = new Date().getTime();
    const randomNum = Math.floor(Math.random() * 10000);
    const uniqueId = `${timestamp}-${randomNum}`;
    return uniqueId;
  };

  //Function to get orders list
  const getQuotesList = async () => {
    setDataLoader(true);
    try {
      const requestResponse = await fetchWithTokenJSONPost(`/quotes/get`, {
        howMany: 2500,
      });
      const jsonResponse = await requestResponse.json();
      if (requestResponse.status === 200) {
        setQuotes(jsonResponse.data);
      } else {
        if (requestResponse.status === 401) {
          window.location.href = "/";
        }
      }
    } catch (error) {
      setDataError(true);
    }
    setDataLoader(false);
  };

  //Function for data query
  const filterData = (query, data) => {
    if (!query) {
      return data;
    } else {
      return searchEngine(data, query);
    }
  };

  //Data in the table
  const dataFiltered = filterData(searchQuery, quotes);

  // ==========>Component<==========
  if (dataError) return <ErrorBox />;

  return (
    <Grid container spacing={1} sx={{ p: 2 }}>
      <Grid item xs={12} align="left">
        <Button startIcon={<ArrowBackIos />} href="/customer-service">
          {"Volver a servicio al cliente"}
        </Button>
      </Grid>
      {dataLoader ? (
        <Grid item xs={12}>
          <DataLoader />
        </Grid>
      ) : (
        <Grid item xs={12}>
          <Card raised sx={{ p: 2 }}>
            <Grid container spacing={2}>
              <Grid item xs={12}>
                <ElementCard
                  ops={{
                    title: "Lista de cotizaciones",
                    details: [`${quotes.length} registradas`],
                  }}
                />
              </Grid>
              <Grid item xs={12}>
                <TextField
                  id="search-bar"
                  onChange={(e) => {
                    setSearchQuery(e.target.value);
                  }}
                  fullWidth
                  label="Buscar"
                  variant="outlined"
                  placeholder="Buscar..."
                />
              </Grid>
              <Grid item xs={12}>
                <TableContainer>
                  <Table aria-label="quotes-table">
                    <TableHead>
                      <TableRow>
                        <TableCell align="center">
                          <Typography fontWeight="bold">
                            No. Cotización
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography fontWeight="bold">
                            Nombre del cliente
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography fontWeight="bold">
                            Productos/Servicios
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography fontWeight="bold">
                            Fecha de creación
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography fontWeight="bold">
                            Fecha de expiración
                          </Typography>
                        </TableCell>
                        <TableCell align="center">
                          <Typography fontWeight="bold">Ver más</Typography>
                        </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {dataFiltered.length ? (
                        dataFiltered
                          .sort(
                            (a, b) =>
                              new Date(b.createdAt) - new Date(a.createdAt)
                          )
                          .slice(
                            page * rowsPerPage,
                            page * rowsPerPage + rowsPerPage
                          )
                          .map((quote) => (
                            <QuoteRow
                              key={`${quote.quoteNumber}-${
                                quote.createdAt
                              }-${generateId()}`}
                              quote={quote}
                            />
                          ))
                      ) : (
                        <TableRow>
                          <TableCell align="center" colSpan={6}>
                            <Typography>
                              No hay cotizaciones registradas
                            </Typography>
                          </TableCell>
                        </TableRow>
                      )}
                    </TableBody>
                  </Table>
                </TableContainer>
                <TablePagination
                  component="div"
                  count={dataFiltered.length}
                  page={page}
                  onPageChange={handleChangePage}
                  rowsPerPage={rowsPerPage}
                  labelRowsPerPage="Filas"
                  onRowsPerPageChange={handleChangeRowsPerPage}
                />
              </Grid>
            </Grid>
          </Card>
        </Grid>
      )}
    </Grid>
  );
}
